import React from "react";
import Box from "@mui/material/Box";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import trayIcon from "../../../assets/icons/tray_vector.svg";
import trapSiteIcon from "../../../assets/icons/trapsite_vector.svg";
import reportIcon from "../../../assets/icons/report_vector.svg";
import logoutIcon from "../../../assets/icons/logout.svg";
import settingIcon from "../../../assets/icons/setting.svg";
import { useState } from "react";
import { useHistory } from "react-router-dom";
import ROUTES from "../../AppRouter/routes";
import { useAuth0 } from "../../../providers";
import ConfirmDialog from "../../ConfirmDialog";
import { connect } from "react-redux";
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";
import WifiIcon from "@mui/icons-material/Wifi";
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import RebootButton from "./RebootButton";
// import GuideIcon from "@mui/icons-material/ChatBubble";
import LightTooltip from "./LightToolTip";
import UserGuideModal from "../SideBar/UserGuides/UserGuideModal";

const NavigationBar = ({ superUser, deviceUuid }) => {

  const [focus, setFocus] = useState(true);
  const history = useHistory();
  const [value, setValue] = useState(0);
  const { logout } = useAuth0();
  const [showLogoutConfirm, setShowLogoutConfirm] = useState(false);
  const [rebootPopup, setRebootPopup] = useState(false);
  const [guideModalOpen, setGuideModalOpen] = useState(false);


  const handleTabChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleLogoutClick = () => {
    setShowLogoutConfirm(true);
  };

  const onConfirm = () => {
    logout();
  };

  return (
    <>
      <ConfirmDialog
        title={"Logout"}
        children={"Are you sure you want to logout?"}
        open={showLogoutConfirm}
        setOpen={setShowLogoutConfirm}
        onConfirm={onConfirm}
      />
      <Box
        onMouseEnter={() => {
          setFocus(true);
        }}
        onMouseLeave={(e) => {
          e.preventDefault();
          // setFocus(false)
        }}
      >
        <Box
          sx={{
            bgcolor: "background.paper",
            display: "flex",
            height: "100vh",
          }}
        >
          <Tabs
            orientation="vertical"
            value={value}
            onChange={handleTabChange}
            sx={{
              borderRight: 1,
              borderColor: "divider",
              ".MuiTabs-flexContainer": {
                display: "flex",
                height: "100vh",
              },
              ".MuiButtonBase-root": {
                minWidth: "90px",
                paddingX: ["8px", "8px", "8px", "12px", "16px", "16px"],
              },
            }}
          >
            <LightTooltip
              title="Trays"
              onClick={() => {
                history.push(ROUTES.traysTab);
              }}
              size="md"
              open={focus}
            >
              <Tab
                icon={
                  <img className={"w-6"} src={trayIcon} alt="Tray Icon"></img>
                }
                onClick={() => {
                  history.push(ROUTES.traysTab);
                }}
              />
            </LightTooltip>
            <LightTooltip
              title={`Collection`}
              title2={"Details"}
              size="md"
              open={focus}
              onClick={() => {
                history.push(ROUTES.trapSite);
              }}
              slotProps={{
                popper: {
                  modifiers: [
                    {
                      name: "offset",
                      options: {
                        offset: [0, -50],
                      },
                    },
                  ],
                  sx: {
                    padding: 0,
                    zIndex: 0,
                  },
                },
              }}
            >
              <Tab
                icon={
                  <img
                    className={"w-10"}
                    src={trapSiteIcon}
                    alt="Collection Sites Icon"
                  />
                }
                // label={focus ? "Collection Sites" : null}
                onClick={() => {
                  history.push(ROUTES.trapSite);
                }}
                sx={{ paddingBottom: "40px" }}
              />
            </LightTooltip>

            <LightTooltip
              title="Reports"
              size="md"
              open={focus}
              onClick={() => {
                history.push(ROUTES.dataTab);
              }}
            >
              <Tab
                icon={
                  <img
                    className={"w-8"}
                    src={reportIcon}
                    alt="Reports Icon"
                  ></img>
                }
                onClick={() => {
                  history.push(ROUTES.dataTab);
                }}
              />
            </LightTooltip>

            <Tab
              sx={{ flexGrow: 1 }}
              onMouseOut={(e) => {
                e.preventDefault();
              }}
            ></Tab>

            {/* User Guide navigation */}
            {/* <LightTooltip
              title="Guide"
              size="md"
              open={focus}
              onClick={() => {
                setGuideModalOpen(true);
              }}
            >
              <Tab
                // label={focus ? "Settings" : null}
                icon={<GuideIcon sx={{ color: "#3B7EB2", fontSize: "32px" }} />}
                alt="Guide Icon"
                className={"w-6 w-full"}
                onClick={() => {
                  setGuideModalOpen(true);
                }}
              />
            </LightTooltip>*/}
            {superUser && (
              <LightTooltip
                title="Admin"
                size="md"
                open={focus}
                onClick={() => {
                  history.push(ROUTES.superUserPanel);
                }}
              >
                <Tab
                  icon={
                    <AdminPanelSettingsIcon
                      sx={{ color: "#3B7EB2", fontSize: "32px" }}
                    />
                  }
                  alt="Admin user Icon"
                  className={"w-full"}
                  onClick={() => {
                    history.push(ROUTES.superUserPanel);
                  }}
                />
              </LightTooltip>
            )}
            {deviceUuid && deviceUuid !== "ALLTRAY" && (
              <LightTooltip
                title="Reboot"
                size="md"
                open={focus}
                onClick={() => {
                  setRebootPopup(true);
                }}
              >
                <Tab
                  icon={
                    <RestartAltIcon
                      sx={{ color: "#3B7EB2", fontSize: "32px" }}
                    />
                  }
                  alt="Reboot"
                  className={"w-full"}
                  onClick={() => setRebootPopup(true)}
                ></Tab>
              </LightTooltip>
            )}
            <LightTooltip
              title="Setup"
              size="md"
              open={focus}
              onClick={() => {
                history.push(ROUTES.deviceSetup);
              }}
            >
              <Tab
                icon={<WifiIcon sx={{ color: "#3B7EB2", fontSize: "32px" }} />}
                onClick={() => {
                  history.push(ROUTES.deviceSetup);
                }}
              />
            </LightTooltip>
            <LightTooltip
              title="Settings"
              size="md"
              open={focus}
              onClick={() => {
                history.push(ROUTES.settings);
              }}
            >
              <Tab
                icon={
                  <img
                    className={"w-6"}
                    src={settingIcon}
                    alt="Settings Icon"
                  ></img>
                }
                onClick={() => {
                  history.push(ROUTES.settings);
                }}
              />
            </LightTooltip>
            <LightTooltip
              title="Logout"
              size="md"
              open={focus}
              placement="bottom"
              onClick={handleLogoutClick}
            >
              <Tab
                icon={
                  <img
                    className={"w-10"}
                    src={logoutIcon}
                    alt="Logout Icon"
                  ></img>
                }
                onClick={handleLogoutClick}
                sx={{ marginBottom: "20px" }}
              />
            </LightTooltip>
          </Tabs>
        </Box>
      </Box>
      {rebootPopup && <RebootButton setModal={setRebootPopup} />}
      {guideModalOpen && (
        <UserGuideModal
          guideModalOpen={guideModalOpen}
          setGuideModalOpen={setGuideModalOpen}
        />
      )}
    </>
  );
};

export const mapStateToProps = (state) => {
  const superUser = state?.user?.superUser || false;
  const selectedDevice = state.devices?.selectedDevice || null;

  return {
    superUser,
    deviceUuid: selectedDevice,
  };
};

export default connect(mapStateToProps, {})(NavigationBar);
